import {StyleSheet} from "aphrodite";
import * as React from "react";
import type {RenderElementProps} from "slate-react";

import {addStyle} from "@khanacademy/wonder-blocks-core";
import {color, spacing} from "@khanacademy/wonder-blocks-tokens";

const StyledTable = addStyle("table");

export default function TableNode(
    props: RenderElementProps,
): React.ReactElement {
    const {attributes, children} = props;

    return (
        <StyledTable {...attributes} style={styles.table}>
            {children}
        </StyledTable>
    );
}

const styles = StyleSheet.create({
    table: {
        marginBlockEnd: spacing.medium_16,
        display: "table",
        width: "100%",
        tableLayout: "fixed",
        border: `1px solid ${color.offBlack16}`,
    },
});
